import React, { useCallback, useEffect, useState } from "react";
import classNames from "classnames/bind";
import PropTypes from "prop-types";
import styles from "./Input.module.css";
import { EyeIcon, HidePasswordIcon } from "../Icons/Icons";
import { isValidateCompanyCode, isValidatePassword, isValidateUserName } from "../../utils";

const cx = classNames.bind(styles);

const Input = ({
  name,
  title,
  onChange,
  value,
  rules,
  type,
  icon,
  placeholder,
  isSubmit,
  row,
  register,
  setIsSubmit,
  stylesMessage
}) => {
  const [isChange, setIsChange] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [types, setTypes] = useState(type);
  const onChanges = (e) => {
    // if (!isChange) {
    setIsChange(true);
    // }
    onChange(e.target.value);
    setIsSubmit(false)
  };
  const checkRules = (value) => {
    if (isChange && rules && rules[0].required) {
      if (!value) {
        return false;
      }
    }
    if (isChange && rules && rules[3]?.userName && value && !isValidateUserName(value)) {
      return false
    }
    if (isChange && rules && rules[3]?.password && value && !isValidatePassword(value)) {
      return false
    }
    if (isChange && rules && rules[1]?.min > value.length) {
      return false;
    }
    if (isChange && rules && rules[2]?.max < value.length) {
      return false;
    }
    if (isChange && rules && rules[1]?.companyCode && !isValidateCompanyCode(value)) {
      return false;
    }
    return true;
  };
  const getMess = (value) => {
    if (rules && rules[0].required) {
      if (!value) {
        return rules[0].mess ? rules[0].mess : "Vui lòng nhập trường này";
      }
    }
    if (isChange && rules && rules[3]?.userName && value && !isValidateUserName(value)) {
      return rules[3]?.mess
        ? rules[3]?.mess
        : "Tên người dùng dài từ 6 - 15 ký tự, chỉ chứa các ký tự viết thường và số.";
    }
    if (isChange && rules && rules[3]?.password && value && !isValidatePassword(value)) {
      return rules[3]?.mess
        ? rules[3]?.mess
        : "Mật khẩu dài 6-20 ký tự, phải chứa ký tự viết hoa, ký tự viết thường, ký tự đặc biệt, ký tự số, không chứa khoảng trắng";
    }
    if (rules && rules[1]?.min > value.length) {
      return rules[1].mess
        ? rules[1].mess
        : "Trường này nhập tối thiểu " + rules[1].min;
    }
    if (rules && rules[2]?.max < value.length) {
      return rules[2].mess
        ? rules[2].mess
        : "Trường này nhập tối da " + rules[2].max;
    }
    if (rules && rules && rules[1]?.companyCode && !isValidateCompanyCode(value)) {
      return rules[1].mess
        ? rules[1].mess
        : "Mã công ty không chứa khoảng trắng";
    }
  };
  useEffect(() => {
    if (isSubmit) {
      setIsChange(true);
    }
  }, [isSubmit]);

  const handleShowPass = useCallback(() => {
    setShowPass(!showPass)
    if (showPass) {
      setTypes('password')
    } else {
      setTypes('text')
    }
  }, [showPass])
  return (
    <div className={cx("form-group", row ? 'form-row' : '')}>
      {icon && <span className={cx("icon")}>{icon}</span>}
      <label>{title}</label>
      <div className={cx("input-block", checkRules(value) ? "" : "input-block-error")}>
        <input
          value={value}
          className={cx(
            "input",
            icon ? "isIcon" : "",
            checkRules(value) ? "" : "input-error"
          )}
          name={name}
          onChange={onChanges}
          type={types}
          placeholder={placeholder}
          maxLength={155}
        />
        {type === 'password' && <span className={cx('eye-icon')} onClick={handleShowPass}>{showPass ? <HidePasswordIcon /> : <EyeIcon />}</span>}
      </div>
      {isChange && !checkRules(value) && (
        <span className={cx("error")} style={{ ...stylesMessage }}>{getMess(value)}</span>
      )}
    </div>
  );
};

Input.propTypes = {
  title: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  rules: PropTypes.array,
  type: PropTypes.string,
  icon: PropTypes.node,
  placeholder: PropTypes.string,
  isSubmit: PropTypes.any,
};

export default Input;
